export const createAmountFormatter = (currency: string) => {
  return (amount?: number | null) => {
    if (amount !== null && amount !== undefined) {
      return `${amount} ${currency}`;
    }
    return `0 ${currency}`;
  };
};
